import { useNavigate } from "react-router-dom";

const FinalCTA = ({
  overline = "Get Started",
  heading = "Choose a Safer, More Strategic Path",
  copy = "Our management consulting focuses on operational resilience, compliance, and governance — areas that deliver predictable results and support sustainable growth.",
  buttonLabel = "Book Your Consultation",
}) => {
  const navigate = useNavigate();
  return (
    <section data-testid="final-cta-section" className="bg-navy">
      <div className="mx-auto max-w-5xl px-6 sm:px-8 lg:px-12 py-24 sm:py-28 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold mb-6">
          {overline}
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">
          {heading}
        </h2>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-300 max-w-2xl mx-auto">
          {copy}
        </p>
        <button
          data-testid="final-cta-button"
          onClick={() => navigate("/contact")}
          className="mt-10 bg-gold text-white hover:bg-gold-hover transition-colors duration-200 px-8 py-4 text-sm font-semibold tracking-wide"
        >
          {buttonLabel}
        </button>
      </div>
    </section>
  );
};

export default FinalCTA;
